<template>
  <div
    class="appointment"
    id="appointment"
    @click="clicked"
    :class="{'border-top': appointment.TimeFrom == '07:00','border-bottom': appointment.TimeTo == '23:00'}"
    :style="{top: topOffset + 'px', height: height + 'px', 
    'border-left-color': appointment.AppointmentColor}">
    <p class="appointmentType" :style="{color: appointment.AppointmentColor}">{{ appointment.AppointmentTypeName }}</p>
    <p class="time">{{ appointment.TimeFrom }} - {{ appointment.TimeTo }}</p>
  </div>
</template>

<script>
export default {
  props: ["appointment", "studioChanged"],
  data() {
    return {
      topOffset: 0,
      height: 0
    };
  },
  methods: {
    clicked(){
      this.$store.commit("setDetailsDialog", true);
      this.$store.commit("setSelectedAppointment", this.appointment.AppointmentId);
    },
    calculateTopOffset() {
      var t = this.appointment.TimeFrom.split(":");
      const minInPixels = 1.666666666666667;
      var h = (parseInt(t[0]) - 7) * 100,
        m = parseInt(t[1]) * minInPixels;
      this.topOffset = h + m;
    },
    calculateHeight() {
      var temp1 = this.appointment.TimeFrom.split(":");
      var temp2 = this.appointment.TimeTo.split(":");
      var t1H,
        t2H,
        t1min,
        t2min,
        tempH,
        tempMin = 0;
      const minInPixels = 1.666666666666667;
      t1H = temp1[0];
      t2H = temp2[0];
      t1min = temp1[1];
      t2min = temp2[1];

      tempH = (parseInt(t2H) - parseInt(t1H)) * 100; // sati u pikselima
      tempMin = parseInt(t2min) * minInPixels - parseInt(t1min) * minInPixels;

      this.height = tempH + tempMin;
    }
  },
  created() {
    this.calculateTopOffset();
    this.calculateHeight();
  },
  watch: {
    studioChanged() {
      this.calculateTopOffset();
      this.calculateHeight();
    }
  }
};
</script>

<style scoped>
#appointment {
  position: absolute;
  z-index: 1;
  background-color: #f7f7f7;
  border-left-width: 2px;
  border-left-style: solid;
  width: 100%;
  padding-left: 5px;
}
p{
  margin: 0;
}
.appointmentType{
  font-weight: 500;
  font-size: 13px;
}
.time{
  color: #657786;
  opacity: 0.87;
  font-size: 10px;
}
.border-top{
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
}
.border-bottom{
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
}
</style>
